import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Option from './option';
import Menu from './menu';
import './styles.css';

class Service1327 extends Component {
  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/

  render() {
    return (
      <div className="service-1327">
        <Switch>
          <Route exact path="/environmental_controls" component={Menu} />
          <Route path="/environmental_controls/:option" component={Option} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1327);
